import { useSessionAuth } from '@/context/Auth';
import { searchChatMessages } from '@/infrastructure/api/chat';
import { ChatMessage } from '@/infrastructure/domain/chat';
import { ListResponse } from '@/infrastructure/domain/list';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

export const useSearchChatMessages = (
  roomId: string,
): UseQueryResult<ListResponse<ChatMessage>, Error> => {
  const { token } = useSessionAuth();

  return useQuery({
    queryKey: ['chatMessages', roomId],
    queryFn: () => searchChatMessages(token!, roomId),
    enabled: Boolean(roomId),
  });
};
